import React from "react";

interface Props {
  children: React.ReactElement;
}

const ResponsiveContentWidthWrapper = ({ children }: Props) => {
  const anyPageClassName =
    "lg:[&>*:first-child]:mt-0 lg:[&>*:first-child]:pt-0 lg:[&>*:last-child]:mb-0 lg:[&>*:last-child]:pb-0";
  const className = `col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 ${anyPageClassName}`;

  return (
    <div className="grid grid-cols-12 gap-6">
      <div className={className}>{children}</div>
    </div>
  );
};

export default ResponsiveContentWidthWrapper;
